export const NIM_TRACK_INNOVATION_MAP = {
    NIA: 'Communication Innovation',
    NIE: 'Ecological Innovation',
    NII: 'Design Innovation',
    NIL: 'Educational Innovation',
    NIP: 'Social Observation and Innovation',
    NIR: 'Academic Research and Innovation',
    NIV: 'Business Venture and Innovation',
    NRI: 'Economic Innovation',
    NSI: 'Sustainability Innovation'
}

export function resolveTrackCode(value) {
    const raw = String(value || '').toUpperCase()
    const codes = Object.keys(NIM_TRACK_INNOVATION_MAP)
    for (let i = 0; i < codes.length; i++) {
        if (raw.indexOf(codes[i]) >= 0) {
            return codes[i]
        }
    }
    return ''
}

export function resolveInnovationName(value) {
    const code = resolveTrackCode(value)
    return code ? NIM_TRACK_INNOVATION_MAP[code] : ''
}
